import { lazy } from 'react'

const checkoutLazy = lazy(() =>
  import(/* webpackChunkName: "checkout" */ './checkout'),
)

export default checkoutLazy
